<h2 mat-dialog-title>
    <span translate *ngIf="isChildren">Additional Children</span>    
    <span translate *ngIf="isAdults">Other Adults</span>
</h2>
<mat-dialog-content>
    <span translate *ngIf="isChildren">On your previous submission this year, the following additional children were listed as living with you.</span>
    <span translate *ngIf="isAdults">On your previous submission this year, the following adults were listed as living with you.</span>

    <div style="padding: 10px 0px" translate>Please check the box next to the names of any who still live in your household.</div>
    <tyl-checkbox *ngFor="let person of previousPeople" id='chkPreviousPerson{{person.ID}}' name='chkPreviousPerson{{person.ID}}' [(checked)]='person.isSelected'>
        <frma-name [firstName]="person.FirstName" [middleName]="person.MiddleName" [lastName]="person.LastName" [suffix]="person.SuffixID | frmaSuffix: suffixes"></frma-name>
    </tyl-checkbox>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button image="next arrow.png" label="Continue" (clickEvent)="continueClick()"></tyl-button>
    </div>
</mat-dialog-actions>
